import Extractor from './extractor.js';

class Video extends Extractor{

  extract(item){
    const result = super.extract(item);
    const data = item.pagemap;

    this.append(result, 'img', 'Image',
      [
        {instance: data, object:'imageobject', property: 'url'},
        {instance: data, object:'metatags', property: 'og:image'},        
        {instance: data, object:'cse_image', property: 'src'},        
      ], null);

    this.append(result, 'datepublished', 'Published',
      [
        {instance: data, object:'videoobject', property: 'datepublished'},  
        {instance: data, object:'videoobject', property: 'uploaddate'},  
      ], null);
  
    this.append(result, 'title', 'Title',
      [
        {instance: data, object:'videoobject', property: 'name'},        
      ], item.title);

    this.append(result, 'body', 'Description',
      [
        {instance: data, object:'videoobject', property: 'description'},        
      ], item.snippet);

    this.append(result, 'duration', 'Duration',
      [
        {instance: data, object:'videoobject', property: 'duration'},        
      ], null);

    this.append(result, 'genre', 'Genre',
      [
        {instance: data, object:'videoobject', property: 'genre'},        
      ], null);

    this.append(result, 'views', 'Views',
      [
        {instance: data, object:'videoobject', property: 'interactioncount'},        
      ], null);

    this.append(result, 'keywords', 'Keywords',
      [
        {instance: data, object:'videoobject', property: 'keywords'},        
      ], null);

    this.append(result, 'user_profile', 'Profile',
      [
        {instance: data, object:'person', property: 'url'},        
      ], null); 

    result['has_data'] = (item.type !== 'imdb' && result['title']) ? 1 : 0;

    return result;
  }
}

export default (Video);


// WEBPACK FOOTER //
// ./src/search/extractor/video.js